import { useState, useEffect } from 'react';

interface GradientButtonProps {
  onClick: () => void;
  label: string;
  shake?: boolean;
  id?: string;
  compact?: boolean;
}

const SHAKE_KEYFRAMES = `
  @keyframes gradientBtnShake {
    0%, 100% { transform: translateX(0); }
    20% { transform: translateX(-4px); }
    40% { transform: translateX(4px); }
    60% { transform: translateX(-3px); }
    80% { transform: translateX(3px); }
  }
`;

const GradientButton = ({ onClick, label, shake = false, id, compact = false }: GradientButtonProps) => {
  const [injected, setInjected] = useState(false);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    if (injected) return;
    const style = document.createElement('style');
    style.textContent = SHAKE_KEYFRAMES;
    document.head.appendChild(style);
    setInjected(true);
    return () => { document.head.removeChild(style); };
  }, []);

  return (
    <button
      onClick={onClick}
      id={id}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        width: '100%',
        padding: compact ? '0.65rem' : '0.8rem',
        background: 'linear-gradient(135deg, #0052D4 0%, #4364F7 100%)',
        border: 'none',
        borderRadius: compact ? '8px' : '10px',
        color: 'white',
        fontSize: compact ? '0.9rem' : '1.05rem',
        fontWeight: 500,
        cursor: 'pointer',
        marginBottom: '0.8rem',
        animation: shake ? 'gradientBtnShake 0.4s ease-in-out' : 'none',
        boxShadow: hovered ? 'inset 0 0 0 100px rgba(0, 0, 0, 0.12)' : 'inset 0 0 0 100px rgba(0, 0, 0, 0)',
        transition: 'box-shadow 0.4s ease',
      }}
    >
      {label}
    </button>
  );
};

export default GradientButton;
